import React, { useEffect, useState } from "react";
import "./machine.css";
import { MessageIcon, EditIcon, CameraIcon, InfoIcon } from "./Icons";
import Function from "./function/index";
import { EditModal } from "./modal/index";
import { useGlobal } from "../global/user";
import { Machine, Oil } from "../api";
import { Modal, Form, Button, Input, Space, Image, Empty, Switch } from "antd";
import axios from "axios";
import { server } from "../api";
//import { FcComments } from "react-icons/fc";

// 走 RTMP 串流（v1/streaming）的機具類型：3 影像機具、8 水情影像、13 鹽霧害影像機具
// 8 的串流資料在 function_11，由後端 streaming.py 的 resolver 依序查 function_3 / function_11，
// 前端不需要區分。
const RTMP_STREAM_TYPES = [3, 8, 13];

export default function MachineLine({ id, data, setMachines, fd }) {
  const { mobileType_id } = data;
  const machine = data;
  const { IP, port } = machine;
  const { user, field } = useGlobal();
  const classlevel = parseInt(user.class, 10);
  const [status, setStatus] = useState(data.functions?.[0]?.status ?? null);
  const [active, setActive] = useState(machine.active === 1 ? true : false);
  const [streamingActive, setStreamingActive] = useState(false);
  const [streamState, setStreamState] = useState(null);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mqttActive, setMqttActive] = useState(false);

  const [form] = Form.useForm();

  const isRtmpStream = RTMP_STREAM_TYPES.includes(mobileType_id);

  useEffect(() => {
    if (!isRtmpStream) return;
    let cancelled = false;
    const fetchState = async () => {
      try {
        const { data } = await axios.get(`${server}v1/streaming/state/${id}`);
        if (!cancelled) setStreamState(data);
      } catch (err) {
        if (!cancelled) setStreamState({ live: "error", active: 0, viewers: 0 });
      }
    };
    fetchState();
    const interval = setInterval(fetchState, 5000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [id, mobileType_id]);

  useEffect(() => {
    if (isRtmpStream && streamState) setStreamingActive(streamState.active === 1);
  }, [streamState, mobileType_id]);

  const machineInfo = {
    IP: data.IP,
    port: data.port,
    name: data.mobile_name,
    fake_update: data.fake_update,
  };
  const DeleteMachine = async () => {
    await Machine.DeleteMachine(machine.id);
    setMachines((data) => data.filter((m) => m.id !== machine.id));
  };
  const ActiveMachine = async () => {
    await Machine.ActiveMachine(data.id, active);
    setActive(!active);
  };
  const onDeleteMachine = () =>
    Modal.confirm({
      title: "確認刪除機具",
      content: `確認刪除機具${data.mobile_name}`,
      onOk: DeleteMachine,
    });

  const onActiveMachine = () =>
    Modal.confirm({
      title: `確認${active ? "關閉" : "啟動"}機具`,
      content: `確認${active ? "關閉" : "啟動"}機具${data.mobile_name}`,
      onOk: ActiveMachine,
    });

  useEffect(() => {
    if (mobileType_id === 9) {
      const fetchInitialStatus = async () => {
        try {
          const response = await Oil.getDeviceConnectStatus(machineInfo.IP, machineInfo.port);
          if (response && response.code === 200) {
            setMqttActive(response.data.connect_status === 1);
          }
        } catch (error) {
          console.error("Failed to fetch initial MQTT status:", error);
        }
      };
      fetchInitialStatus();
    }
  }, []);

  const toggleStreaming = async () => {
    const prev = streamingActive;
    const nextActive = prev ? 0 : 1;
    setStreamingActive(!prev);
    try {
      await axios.post(`${server}v1/streaming/active`, {
        deviceID: id,
        active: nextActive,
      });
    } catch (err) {
      setStreamingActive(prev);
      Modal.error({
        title: "操作失敗",
        content: err.response?.data?.error || err.message || "請稍後再試",
      });
    }
  };

  const toggleMqttConnection = async () => {
    if (isLoading) return; // 防止頻繁點擊
    setIsLoading(true); // 開始載入
    const command = mqttActive ? "stop" : "start";
    try {
      const response = await Oil.controlDevice(machineInfo.IP, machineInfo.port, command);
      if (response && response.code === 200 && response.data.success) {
        setMqttActive(!mqttActive);
      } else {
        console.error("Failed to toggle MQTT connection:", response);
      }
    } catch (error) {
      console.error("Error controlling device:", error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  // 影像類機具對低權限使用者永遠顯示；其餘機具停用時隱藏。
  // 這個提前 return 必須放在所有 hook 之後，否則 render 之間 hook 數量會改變。
  if (!active && classlevel <= 2 && !isRtmpStream) return null;

  return (
    <React.Fragment>
      <Modal open={openMessageDialog} onCancel={() => setOpenMessageDialog(false)} title="發送測試訊息" onOk={() => form.submit()}>
        <Form
          // labelCol={{ span: 4 }}
          // wrapperCol={{ span: 14 }}
          // layout="horizontal"
          // style={{ maxWidth: 600 }}
          form={form}
          onFinish={() => {
            let { msg } = form.getFieldsValue();
            msg = msg === undefined ? "測試" : msg;
            axios.post(`${server}trigger/token/message/${field}`, {
              msg: msg,
            });
            setOpenMessageDialog(false);
          }}
        >
          <Form.Item name="msg" label="訊息" required={true}>
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
      <tr key={`row-${id}-0`}>
        <td className="ant-table-cell name-cell" key={`Name-${id}`} style={{ verticalAlign: "middle" }} rowSpan={machine.functions.length}>
          <div className="name my-2">
            <Space className="mx-auto px-1" direction="vertical" size="small">
              <h6 className="text-center">{machine.mobile_name}</h6>
              <Space>
                <MessageButton OnClick={setOpenMessageDialog} disable={classlevel < 3} />
                <EditButton machine={machine} setMachines={setMachines} disable={classlevel < 3} />
                <MediaButton src={machine.image} />
                {mobileType_id !== 8 && <InfoButton machine={machine} />}
              </Space>
            </Space>
          </div>
        </td>
        <Function functionType={machine.functions[0].type} mobileTypeId={mobileType_id} data={machine.functions[0]} status={status} setStatus={setStatus} machineInfo={machineInfo} />
        <td className="ant-table-cell align-middle text-center" rowSpan={machine.functions.length}>
          {(() => {
            switch (mobileType_id) {
              case 3:
              case 8:
              case 13:
                if (!streamState) return "未上線";
                switch (streamState.live) {
                  case "streaming":
                    return `串流中 (${streamState.viewers ?? 0}人)`;
                  case "starting":
                    return "啟動中…";
                  default:
                    return "未上線"; // idle / error / 連不到鏡頭 一律視為未上線
                }
              case 9:
                return mqttActive ? "監測中" : "未上線";
              case 10:
              case 12:
                return "監測中";
              default:
                return status === 1 || status === "1" ? "監測中" : "未上線";
            }
          })()}
        </td>
        <td key={`Setting-${id}`} className="ant-table-cell name-cell align-middle text-center" rowSpan={machine.functions.length}>
          {(() => {
            switch (mobileType_id) {
              case 3:
              case 8:
              case 13:
                return (
                  <Button
                    onClick={toggleStreaming}
                    style={{
                      background: "var(--content-background)",
                      color: "var(--primary-text)",
                      border: "2px solid var(--primary-border)",
                      boxShadow: "0 0 0 1px var(--primary-border)"
                    }}
                  >
                    {streamingActive ? "關閉" : "串流"}
                  </Button>
                );

              case 10:
              case 12:
                return null;

              case 9:
                if (classlevel > 2) {
                  return (
                    <Button
                      onClick={toggleMqttConnection}
                      disabled={isLoading}
                      className={isLoading ? "loading-button" : mqttActive ? "mqtt-active" : "mqtt-inactive"}
                      style={{
                        background: "var(--content-background)",
                        color: "var(--primary-text)",
                        border: "2px solid var(--primary-border)",
                        boxShadow: "0 0 0 1px var(--primary-border)"
                      }}
                    >
                      {isLoading ? "處理中..." : mqttActive ? "關閉" : "啟動"}
                    </Button>
                  );
                }
                return null;

              default:
                if (classlevel > 2) {
                  return <Button onClick={onActiveMachine} style={{
                    background: "var(--content-background)",
                    color: "var(--primary-text)",
                    border: "2px solid var(--primary-border)",
                    boxShadow: "0 0 0 1px var(--primary-border)"
                  }}>{active ? "關閉" : "啟動"}</Button>;
                }
                return null;
            }
          })()}

          {classlevel > 2 && <Button style={{
            marginLeft: 5,
            background: "var(--content-background)",
            color: "var(--primary-text)",
            border: "2px solid var(--primary-border)",
            boxShadow: "0 0 0 1px var(--primary-border)"
          }} danger onClick={onDeleteMachine}>刪除</Button>}
        </td>
      </tr>
      {machine.functions.length > 1
        ? machine.functions.map((func, index) =>
            index > 0 ? (
              <tr key={`row-${id}-${index}`}>
                <Function functionType={func.type} data={func} status={status} setStatus={setStatus} machineInfo={machineInfo} fdd={fd} />
              </tr>
            ) : undefined
          )
        : undefined}
    </React.Fragment>
  );
}

function MediaButton({ src }) {
  const [visible, setVisible] = useState(false);
  const [mediaUrl, setMediaUrl] = useState("");
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isPanoramaMode, setIsPanoramaMode] = useState(false);
  const [isVideo, setIsVideo] = useState(false);

  // 按照檔案類型判斷是影片還是圖片
  const getFileType = (filename) => {
    if (!filename) return { isVideo: false, isImage: false };

    const extension = filename.toLowerCase().split('.').pop();
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp'];
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico'];

    return {
      isVideo: videoExtensions.includes(extension),
      isImage: imageExtensions.includes(extension)
    };
  };

  const onClick = () => {
    if (src === "None" || !src) {
      setErrorMessage("尚未設置媒體URL");
      setHasError(true);
      setVisible(true);
      return;
    }

    const filename = src.includes('/') ? src.split('/').pop() : src;
    const fileType = getFileType(filename);

    const url = `https://1.iotwebhub.net/assets/images/${filename}`;
    // const url = `http://localhost:2391/image/${filename}`;

    // console.log("媒體URL:", url);
    // console.log("檔案類型:", fileType);
    // console.log("360全景圖片CDN URL:", `https://cdn.pannellum.org/2.5/pannellum.htm#panorama=${url}`);

    setMediaUrl(url);
    setIsVideo(fileType.isVideo);
    setHasError(false);
    setErrorMessage("");
    setVisible(true);
  };

  const toggleMode = (checked) => {
    setIsPanoramaMode(checked);
    setHasError(false);
    setErrorMessage("");
  };

  return (
    <div>
      <button className="control_setting" type="button" onClick={onClick}>
        <CameraIcon className="button_svg control_svg" />
      </button>
      <Modal
        open={visible}
        title={"相片/影片檢視"}
        onCancel={() => setVisible(false)}
        footer={[
          // 只有圖片才顯示360全景模式開關
          !isVideo && (
            <div key="toggle-mode-switch" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>360 全景模式</span>
              <Switch
                checked={isPanoramaMode}
                onChange={toggleMode}
              />
            </div>
          ),
          <Button onClick={() => setVisible(false)} key="close-button">
            關閉
          </Button>,
        ].filter(Boolean)}
        width={'85%'}
        centered
      >
        <div style={{ textAlign: 'center', minHeight: isVideo ? '450px' : (isPanoramaMode ? '400px' : '300px'), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {hasError ? (
            <Empty
              description={errorMessage || "媒體載入失敗"}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ) : isVideo ? (
            <video
              controls
              style={{
                maxWidth: '100%',
                maxHeight: '85vh',
                width: '100%'
              }}
              onError={() => {
                setHasError(true);
                setErrorMessage("影片載入失敗");
              }}
            >
              <source src={mediaUrl} type="video/mp4" />
              <source src={mediaUrl} type="video/webm" />
              <source src={mediaUrl} type="video/ogg" />
              您的瀏覽器不支援影片播放。
            </video>
          ) : isPanoramaMode ? (
            <iframe
              width="100%"
              height="400"
              allowFullScreen
              style={{ border: 'none' }}
              src={`https://cdn.pannellum.org/2.5/pannellum.htm#panorama=${mediaUrl}`}
              title="Panorama Viewer"
              onError={() => {
                setHasError(true);
                setErrorMessage("360全景影像載入失敗");
              }}
            />
          ) : (
            <img
              src={mediaUrl}
              alt="Machine Media"
              style={{
                maxWidth: '100%',
                maxHeight: '85vh',
                objectFit: 'contain'
              }}
              onError={() => {
                setHasError(true);
                setErrorMessage("影像載入失敗");
              }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
}

function MessageButton({ OnClick, disable }) {
  return (
    <div style={{ display: disable ? "none" : "block" }}>
      <button className="control_setting" type="button" onClick={() => OnClick(true)}>
        <MessageIcon className="button_svg control_svg" />
      </button>
    </div>
  );
}

function EditButton({ machine, setMachines, disable }) {
  const [onEdit, setOnEdit] = useState(false);
  return (
    <div style={{ display: disable ? "none" : "block" }}>
      <button className="control_setting" type="button" onClick={() => setOnEdit(true)}>
        <EditIcon className="button_svg control_svg" />
      </button>
      <EditModal onEdit={onEdit} setOnEdit={setOnEdit} machine={machine} setMachines={setMachines} />
    </div>
  );
}

function InfoButton({ machine }) {
  const [info, setInfo] = useState({
    ProcessCommands: [],
    connected: "未知",
    field: "未知",
    name: "未知",
  });
  const [visible, setVisible] = useState(false);
  useEffect(async () => {
    if (!visible) return;
    const { IP, port } = machine;
    const response = await Machine.GetServerStatus(IP, port);
    if (response.code === 200) {
      setInfo(response.data);
    }
  }, [visible]);
  const formItemLayout = {
    labelCol: {
      sm: {
        span: 9,
      },
    },
    wrapperCol: {
      sm: {
        span: 15,
      },
    },
  };
  return (
    <div>
      <button className="control_setting" type="button" onClick={() => setVisible(true)}>
        <InfoIcon className="button_svg control_svg" />
      </button>
      <Modal
        open={visible}
        title="機具狀態"
        onCancel={() => setVisible(false)}
        footer={[
          <Button onClick={() => setVisible(false)} key="back-button">
            返回
          </Button>,
        ]}
      >
        <Form {...formItemLayout}>
          <Form.Item label="機具場域">{info.field}</Form.Item>
          <Form.Item label="機具名稱">{info.name}</Form.Item>
          <Form.Item label="機具狀態">{info.connected ? "已連線" : "未連線"}</Form.Item>
          <Form.Item label="執行數量">{info.ProcessCommands.length}</Form.Item>
        </Form>
      </Modal>
    </div>
  );
}